export enum MimeType {
  Pdf = 'application/pdf',
  Jpeg = 'image/jpeg',
  Png = 'image/png',
  WebP = 'image/webp',
  Gif = 'image/gif',
}

export enum MaterialIcon {
  Pdf = 'picture_as_pdf',
  Image = 'image',
}

export const FileSizeLimit = {
  PHOTO: 5 * 1024 * 1024,
  DOCUMENT: 10 * 1024 * 1024,
} as const;

export const MimeTypePreset = {
  IMAGES: [ MimeType.Jpeg, MimeType.Png, MimeType.WebP ] as string[],
  IMAGES_WITH_GIF: [ MimeType.Jpeg, MimeType.Png, MimeType.WebP, MimeType.Gif ] as string[],
  DOCUMENTS: [ MimeType.Pdf, MimeType.Jpeg, MimeType.Png, MimeType.WebP ] as string[],
} as const;

export interface FileValidationResult {
  valid: boolean;
  errorKey?: string;
}

export function validateFile(
  file: File,
  allowedMimeTypes: readonly string[],
  maxSizeBytes: number,
  errorKeys: { invalidType: string; tooLarge: string },
): FileValidationResult {
  if (!allowedMimeTypes.includes(file.type)) {
    return { valid: false, errorKey: errorKeys.invalidType };
  }
  if (file.size > maxSizeBytes) {
    return { valid: false, errorKey: errorKeys.tooLarge };
  }
  return { valid: true };
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) {
    return `${ bytes } B`;
  }
  if (bytes < 1024 * 1024) {
    return `${ (bytes / 1024).toFixed(1) } KB`;
  }
  return `${ (bytes / (1024 * 1024)).toFixed(1) } MB`;
}

export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

export function getMimeTypeIcon(mimeType: string): string {
  if (mimeType === MimeType.Pdf) {
    return MaterialIcon.Pdf;
  }
  return MaterialIcon.Image;
}
